export {
  /**
   * @deprecated - this bundle should be a shared layer
   */
  truncToPlace,
} from './utils/numberUtils';
